import { about } from "./about";
import { projects } from "./projects";

export const images = {
  about: { ...about },
  projects: { ...projects },
};

export { icons } from "./icons";
